<template>
  <div>
    <v-dialog v-model="createDialog" max-width="450px">
      <v-card>
        <v-card-title>配信種別選択</v-card-title>
        <v-card-text>
          <p>新規作成する配信の種別を選択してください。</p>
          <v-row>
            <v-col>
              <v-btn
                v-if="hasEditAuth('PU')"
                class="mx-2"
                color="primary"
                style="width: 100%"
                @click="movePushNotification"
                >{{ namePush }}</v-btn
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                v-if="hasEditAuth('LA')"
                class="mx-2"
                color="primary"
                style="width: 100%"
                @click="moveEmergencyMail"
                >{{ nameEmergency }}</v-btn
              >
            </v-col>
          </v-row>
          <v-card-actions>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn class="mx-2" color="primary" @click="createDialog = false"
                >キャンセル</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-sheet elevation="1">
      <v-toolbar dense color="white">
        <v-toolbar-title>{{ screenTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          v-if="!isViewMode"
          class="mx-2"
          color="primary"
          @click="createItem()"
        >
          「新規登録」はこのボタンを押してください
        </v-btn>
      </v-toolbar>
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <p style="margin: 5px 0 15px 0">
          住民向け広報管理は下の表を参照してください。条件を指定することで一覧から絞り込むことができます。
        </p>
        <v-row>
          <v-col cols="6" md="3">
            <v-select
              v-model="disasterNameFilterValue"
              :items="disaster"
              item-text="disaster_name"
              item-value="disaster_no"
              label="災害名称"
              placeholder="選択してください"
              clearable
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="emergClsFilterValue"
              :items="getEmergencyClasses"
              label="緊急事態区分"
              placeholder="選択してください"
              item-text="name"
              item-value="emergencyClass"
              clearable
              outlined
            >
              <template v-slot:selection="data">
                {{ emergencyClassItems(data.item) }}
              </template>
              <template v-slot:item="data">
                {{ emergencyClassItems(data.item) }}
              </template>
            </v-select>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="ordertypeFilterValue"
              :items="deliveryTypes"
              label="配信種別"
              placeholder="選択してください"
              clearable
              outlined
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <v-select
              v-model="orderStatusFilterValue"
              :items="orderStatus"
              label="配信状況"
              placeholder="選択してください"
              multiple
              clearable
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="translationStatusFilterValue"
              :items="translationStatus"
              label="翻訳状況"
              placeholder="選択してください"
              clearable
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="1">
            <v-checkbox v-model="lineFilterValue" label="LINE" class="mx-1">
            </v-checkbox>
          </v-col>
          <v-col cols="1">
            <v-checkbox
              v-model="twitterFilterValue"
              label="Twitter"
              class="mx-1"
            >
            </v-checkbox>
          </v-col>
        </v-row>
        <datetime-picker
          :title="'配信日時(開始)'"
          :without-now="true"
          :max="endDateValue"
          :selectedDatetime.sync="startDateValue"
        />
        <datetime-picker
          :title="'配信日時(終了)'"
          :without-now="true"
          :min="startDateValue"
          :selectedDatetime.sync="endDateValue"
        />
        <v-divider class="mb-1"></v-divider>
      </v-container>

      <top-operation-data-table
        ref="topOpeDataTable"
        :headers="deliveryTableHeader"
        :items="convertDisasterDelivery"
        class="elevation-1 table-flex"
        locale="ja-jp"
        item-key="order_id"
        dispMode="nowrap"
        :sort-by="['delivery_date']"
        :sort-desc="true"
        must-sort
      >
        <template v-slot:[`item.delivery_date`]="{ item }">
          {{ formatDatetime(item.delivery_date) }}
        </template>
        <template v-slot:[`item.delivery_status`]="{ item }">
          <template v-if="item.delivery_status === '0'"> 未配信 </template>
          <template v-if="item.delivery_status === '1'"> 配信中 </template>
          <template
            v-if="item.delivery_status === '2' && !isExistsErrorStatus(item)"
          >
            配信済
          </template>
          <template
            v-if="
              item.delivery_ca === 'PU' &&
                item.delivery_status !== '0' &&
                item.delivery_status !== '1' &&
                isExistsErrorStatus(item)
            "
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  配信失敗
                </span>
              </template>
              <span>{{ getErrorContents(item) }}</span>
            </v-tooltip>
          </template>
          <template
            v-if="item.delivery_ca === 'LA' && item.delivery_status === '3'"
          >
            配信失敗
          </template>
          <template
            v-if="item.delivery_status === '4' && !isExistsErrorStatus(item)"
          >
            一部配信
          </template>
        </template>
        <template v-slot:[`item.emerg_cls`]="{ item }">
          <template v-if="item.emerg_cls === 'AL'"> ＡＬ：警戒事態 </template>
          <template v-if="item.emerg_cls === 'SE'">
            ＳＥ：施設敷地緊急事態
          </template>
          <template v-if="item.emerg_cls === 'GE'">
            ＧＥ：全面緊急事態
          </template>
          <template v-if="item.emerg_cls === 'FN'"> 終結 </template>
        </template>
        <template v-slot:[`item.delivery_ca`]="{ item }">
          <template v-if="item.delivery_ca == 'PU'"> {{ namePush }} </template>
          <template v-else-if="item.delivery_ca == 'LA'">
            {{ nameEmergency }}
          </template>
          <template v-else> - </template>
        </template>
        <template v-slot:[`item.is_post_line`]="{ item }">
          <div v-if="item.is_post_line == '1'">あり</div>
          <div v-else>-</div>
        </template>
        <template v-slot:[`item.is_post_twitter`]="{ item }">
          <div v-if="item.is_post_twitter == '1'">あり</div>
          <div v-else>-</div>
        </template>
        <template v-slot:[`item.translation_status_en`]="props">
          <div v-if="props.item.translation_status_en == '0'">翻訳待ち</div>
          <div v-else-if="props.item.translation_status_en == '1'">
            翻訳済み
          </div>
          <div v-else>-</div>
        </template>
        <template v-slot:[`item.translation_status_ko`]="{ item }">
          <div v-if="item.translation_status_ko == '0'">翻訳待ち</div>
          <div v-else-if="item.translation_status_ko == '1'">翻訳済み</div>
          <div v-else>-</div>
        </template>
        <template v-slot:[`item.translation_status_zh_cn`]="{ item }">
          <div v-if="item.translation_status_zh_cn == '0'">翻訳待ち</div>
          <div v-else-if="item.translation_status_zh_cn == '1'">翻訳済み</div>
          <div v-else>-</div>
        </template>
        <template v-slot:[`item.translation_status_zh_tw`]="{ item }">
          <div v-if="item.translation_status_zh_tw == '0'">翻訳待ち</div>
          <div v-else-if="item.translation_status_zh_tw == '1'">翻訳済み</div>
          <div v-else>-</div>
        </template>

        <template v-slot:[`item.delivery_body`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="d-inline-block text-truncate"
                style="max-width: 720px"
              >
                {{ item.delivery_body }}
              </span>
            </template>
            <span>{{ item.delivery_body }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div v-if="isViewMode">
            <v-btn small class="mx-2" color="primary" @click="viewItem(item)">
              参照
            </v-btn>
          </div>
          <div v-else>
            <v-btn
              small
              class="mx-2"
              color="primary"
              v-if="
                ['2', '3', '4'].includes(item.delivery_status) &&
                  isExistsErrorStatus(item) &&
                  hasUpdateAuthorityByItem(item)
              "
              @click="reSendItem(item)"
            >
              再送信
            </v-btn>
            <v-btn
              small
              class="mx-2"
              color="primary"
              v-if="
                (['0'].includes(item.delivery_status) ||
                  (['4'].includes(item.delivery_status) &&
                    !isExistsErrorStatus(item))) &&
                  hasUpdateAuthorityByItem(item)
              "
              @click="editItem(item)"
            >
              編集
            </v-btn>
            <v-btn small class="mx-2" color="primary" @click="viewItem(item)">
              参照
            </v-btn>
            <v-btn
              small
              class="mx-2"
              color="primary"
              v-if="
                (['0'].includes(item.delivery_status) ||
                  isAllErrorStatus(item)) &&
                  hasDeleteAuthorityByItem(item)
              "
              @click="deleteItem(item)"
            >
              削除
            </v-btn>
          </div>
        </template>
      </top-operation-data-table>

      <v-row>
        <v-col cols="12">
          <div class="d-flex">
            <v-btn color="primary" @click="reload"> 最新の情報に更新 </v-btn>
            <div class="mt-2 ml-1 caption">※最新の情報に更新します。</div>
          </div>
        </v-col>
      </v-row>
    </v-sheet>

    <confirm-dialog ref="confirmView" />
    <v-overlay :value="overlay" opacity="1" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import Vue from "vue";
import DatetimePicker from "@/components/DatetimePicker";
import ConfirmDialog from "@/components/ConfirmDialog";
import messageUtils from "@/mixins/message-utils";
import Disaster from "@/plugins/disaster";
import disasterUtils from "@/mixins/disaster-utils";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { ScreenId } from "@/js/value-objects/screen-id";
import { ScreenCrud } from "@/js/value-objects/screen-crud";
import { hasProperty } from "@/js/utils";
import { EmergencyClass } from "@/js/value-objects/emergency-class";
import { PushNotificationTranslator } from "@/js/translators/pushNotificationTranslator";
const disasterDeliveryDetailRepository = RepositoryFactory.get(
  "disasterDeliveryDetail"
);

const pushNotification = "プッシュ通知";
const emergencyMail = "緊急速報メール";
const DELIVERY_STATUS_NON = "0"; //未配信
const DELIVERY_STATUS_LIVE = "1"; //配信中
const DELIVERY_STATUS_DONE = "2"; //配信済
const DELIVERY_STATUS_ERR = "3"; //配信失敗
const DELIVERY_STATUS_PART = "4"; //一部配信

const IS_POST = "1"; //あり

Vue.use(Disaster);
export default {
  mixins: [disasterUtils, messageUtils],
  components: {
    ConfirmDialog,
    DatetimePicker,
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    TopOperationDataTable: () => import("@/components/ui/TopOperationDataTable")
  },
  data: () => ({
    screenTitle: "",
    screenId: "",
    hasDeleteAuthority: false,
    namePush: pushNotification,
    nameEmergency: emergencyMail,
    overlay: false,
    isViewMode: false,
    deleteOrderId: null,
    startDateValue: "",
    endDateValue: "",
    disasterNameFilterValue: "",
    selectedDisasterDateFrom: "",

    ordertypeFilterValue: "",
    deliveryTypes: [
      { value: "PU", text: pushNotification },
      { value: "LA", text: emergencyMail }
    ],
    orderStatusFilterValue: "",
    orderStatus: [
      {
        value: "0",
        text: "未配信"
      },
      {
        value: "1",
        text: "配信中"
      },
      {
        value: "2",
        text: "配信済"
      },
      {
        value: "3",
        text: "配信失敗"
      },
      {
        value: "4",
        text: "一部配信"
      }
    ],
    translationStatusFilterValue: "",
    translationStatus: [
      {
        value: "1",
        text: "翻訳済み"
      },
      {
        value: "0",
        text: "翻訳待ち"
      }
    ],
    emergClsFilterValue: "",
    lineFilterValue: "",
    twitterFilterValue: "",
    emergencyClasses: [],
    disasters: [],
    disasterDeliverys: [],
    createDialog: false
  }),

  mounted() {
    this.pageTitle(this.screenTitle);
  },

  created() {
    this.initialize();
  },

  computed: {
    deliveryTableHeader() {
      return [
        {
          text: "配信日時",
          value: "delivery_date",
          filter: this.registrationDateFilter
        },
        {
          text: "災害番号",
          value: "disaster_no",
          align: " d-none",
          filter: this.disasterNameFilter
        },
        {
          text: "配信番号",
          value: "delivery_no",
          align: " d-none",
          filter: this.deliveryNoFilter
        },
        {
          text: "災害名称",
          value: "disaster_name"
        },
        {
          text: "緊急事態区分",
          value: "emerg_cls",
          filter: this.emergClsFilter,
          sort: this.emergClsSorter
        },
        {
          text: "配信種別",
          value: "delivery_ca",
          filter: this.orderTypeFilter
        },
        {
          text: "LINE連携",
          value: "is_post_line",
          filter: this.lineFilter
        },
        {
          text: "Twitter連携",
          value: "is_post_twitter",
          filter: this.twitterFilter
        },
        {
          text: "配信状況",
          value: "delivery_status"
        },
        {
          text: "翻訳\r\n(英)",
          value: "translation_status_en"
        },
        {
          text: "翻訳\r\n(韓)",
          value: "translation_status_ko"
        },
        {
          text: "翻訳\r\n(中簡)",
          value: "translation_status_zh_cn"
        },
        {
          text: "翻訳\r\n(中繁)",
          value: "translation_status_zh_tw"
        },
        {
          text: "配信タイトル",
          value: "delivery_title"
        },
        {
          text: "配信内容",
          value: "delivery_body"
        },
        {
          text: "操作",
          value: "actions",
          sortable: false
        }
      ];
    },
    // 発災情報
    disaster() {
      return this.$store.state.disasterInfo.data.results;
    },
    // 住民向け広報一覧情報
    disasterDelivery() {
      return this.$store.state.disasterDelivery.data.results;
    },
    // 配信状況変換
    convertDisasterDelivery() {
      let convertDisasterDelivery = this.disasterDeliverys;
      convertDisasterDelivery.forEach(obj => {
        // 配信状況が配信済かつ
        // 翻訳ステータスに未翻訳の言語があれば配信状況を一部配信に変更
        if (
          obj.delivery_status === "2" &&
          (obj.translation_status_en === "0" ||
            obj.translation_status_ko === "0" ||
            obj.translation_status_zh_cn === "0" ||
            obj.translation_status_zh_tw === "0")
        ) {
          obj.delivery_status = "4";
        }
      });
      return convertDisasterDelivery;
    },
    // 緊急事態区分
    getEmergencyClasses() {
      return this.emergencyClasses;
    },
    displayStartDateValue: {
      get: function() {
        return this.formatDate(this.startDateValue);
      },
      set: function() {}
    },

    displayEndDateValue: {
      get: function() {
        return this.formatDate(this.endDateValue);
      },
      set: function() {}
    },

    formatDate: function() {
      return function(date) {
        return date ? this.$moment(date).format("YYYY/MM/DD") : "";
      };
    }
  },

  methods: {
    async initialize() {
      this.overlay = true;
      const screen = this.$screenOperationAuthority(
        ScreenId.SF0301,
        ScreenId.SF0302
      );
      this.readOnly = screen.readOnly;
      this.screenId = screen.screenId;
      this.screenTitle = screen.screenTitle;
      this.hasDeleteAuthority = screen.hasDeleteAuthority;
      this.emergencyClasses = EmergencyClass.listAll();
      if (this.screenId == "SF0301") {
        this.isViewMode = true;
      }
      await Promise.all([
        this.$store.dispatch("disasterInfo/loadDisasterInfo", this.screenId),
        this.$store.dispatch("disasterDelivery/loadDisasterDelivery")
      ]).catch(e => {
        this.handleError(e, screen, "aggregation-menu");
      });
      if (hasProperty(this.$disaster, "disaster_no")) {
        this.disasterNameFilterValue = this.$disaster.disaster_no;
      }

      this.disasters = this.$store.state.disasterInfo.data.results;
      this.disasterDeliverys = this.$store.state.disasterDelivery.data.results;

      this.overlay = false;
    },

    createItem() {
      this.createDialog = true;
    },

    movePushNotification() {
      this.$router.push({
        name: "push-notification-create"
      });
    },

    moveEmergencyMail() {
      this.$router.push({
        name: "emergency-mail-create"
      });
    },

    // 再送信処理
    async reSendItem(item) {
      let message = [
        "配信に失敗した情報を、再送信します。",
        "よろしいですか？"
      ];
      let buttonName = "送信";
      if (!(await this.openConfirm(message, buttonName))) {
        return false;
      }
      // 再送信
      this.overlay = true;
      let payload = PushNotificationTranslator.toResendPayload(item);
      this.clearMessage();
      await disasterDeliveryDetailRepository
        .resend(this.screenId, payload)
        .then(response => {
          this.handleSuccess(response);
        })
        .catch(e => {
          this.handleUpdateError(e);
        });
      // 一覧取得
      await this.$store
        .dispatch("disasterDelivery/loadDisasterDelivery")
        .catch(e => {
          this.handleError(e, screen, "aggregation-menu");
        });
      this.disasterDeliverys = this.$store.state.disasterDelivery.data.results;
      this.overlay = false;
    },

    // 編集処理
    editItem(item) {
      if (item.delivery_ca === "PU") {
        this.$router.push({
          name: "push-notification-edit",
          params: {
            delivery_no: item.delivery_no
          }
        });
      }
      if (item.delivery_ca === "LA") {
        this.$router.push({
          name: "emergency-mail-edit",
          params: {
            delivery_no: item.delivery_no
          }
        });
      }
    },

    // 参照処理
    viewItem(item) {
      if (item.delivery_ca === "PU") {
        this.$router.push({
          name: "push-notification-view",
          params: {
            delivery_no: item.delivery_no
          }
        });
      }
      if (item.delivery_ca === "LA") {
        this.$router.push({
          name: "emergency-mail-view",
          params: {
            delivery_no: item.delivery_no
          }
        });
      }
    },

    // 編集画面の権限があるかチェック
    hasEditAuth(deliveryCa) {
      let editScreenId = "";
      if (deliveryCa === "PU") {
        editScreenId = ScreenId.SF0305;
      } else {
        editScreenId = ScreenId.SF0308;
      }
      const editAuth = this.$screenAuthority.find(
        auth => auth.screen_id === editScreenId
      );
      if (editAuth) {
        const screenCrud = ScreenCrud.factory(editAuth.screen_crud);
        return screenCrud.isOperation();
      } else {
        return false;
      }
    },

    // 削除処理
    async deleteItem(item) {
      let message = "この広報内容を削除してもよろしいですか？";
      let buttonName = "削除";
      if (!(await this.openConfirm(message, buttonName))) {
        return false;
      }
      message = "削除した場合には元に戻せません。本当によろしいですか？";
      if (!(await this.openConfirm(message, buttonName))) {
        return false;
      }
      // 削除
      this.overlay = true;
      const payload = PushNotificationTranslator.toDeletePayload(item);
      this.clearMessage();
      await disasterDeliveryDetailRepository
        .delete(this.screenId, payload)
        .then(response => {
          this.handleSuccess(response);
        })
        .catch(e => {
          this.handleUpdateError(e);
        });
      // 一覧取得
      await this.$store
        .dispatch("disasterDelivery/loadDisasterDelivery")
        .catch(e => {
          this.handleError(e, screen, "aggregation-menu");
        });
      this.disasterDeliverys = this.$store.state.disasterDelivery.data.results;
      this.overlay = false;
    },

    // 全種類失敗判定
    // プッシュ通知、LINE、Twitterが配信に失敗または
    // 緊急速報メールの配信に失敗した場合 true
    isAllErrorStatus(item) {
      if (item.delivery_ca === "PU") {
        if (
          item.is_post_line === IS_POST &&
          item.line_delivery_status !== DELIVERY_STATUS_ERR
        ) {
          return false;
        }
        if (
          item.is_post_twitter === IS_POST &&
          item.twitter_delivery_status !== DELIVERY_STATUS_ERR
        ) {
          return false;
        }
      }
      if (item.delivery_status !== DELIVERY_STATUS_ERR) {
        return false;
      }
      return true;
    },

    //配信失敗の有無判定
    // プッシュ通知、LINE、Twitterのいずれかの配信が失敗した場合、または
    // 緊急速報メールの配信に失敗した場合 true
    isExistsErrorStatus(item) {
      if (
        item.delivery_status === DELIVERY_STATUS_ERR ||
        item.line_delivery_status === DELIVERY_STATUS_ERR ||
        item.twitter_delivery_status === DELIVERY_STATUS_ERR
      ) {
        return true;
      }
      return false;
    },

    // ツールチップの表示内容取得処理
    getErrorContents(item) {
      let errorMeg = "配信失敗：";
      if (item.delivery_status === DELIVERY_STATUS_ERR) {
        errorMeg = errorMeg + "プッシュ通知、";
      }
      if (item.line_delivery_status === DELIVERY_STATUS_ERR) {
        errorMeg = errorMeg + "LINE、";
      }
      if (item.twitter_delivery_status === DELIVERY_STATUS_ERR) {
        errorMeg = errorMeg + "Twitter";
      }
      if (errorMeg.endsWith("、")) {
        errorMeg = errorMeg.slice(0, -1);
      }
      return errorMeg;
    },

    // 確認ダイアログ表示
    openConfirm(message, buttonName) {
      return this.$refs.confirmView.open(message, buttonName);
    },

    // 日付表示形式編集
    formatDatetime(datetime) {
      if (!datetime) {
        return "";
      }
      const formattedDatetime = this.$moment(datetime, "YYYYMMDDHHmmssSSS");
      if (!formattedDatetime.isValid()) {
        return "";
      }
      return formattedDatetime.format("YYYY/MM/DD HH:mm");
    },

    // 緊急事態区分表示編集
    emergencyClassItems(item) {
      const EMERGENCY_NAME = EmergencyClass.factory(
        item.emergencyClass
      ).toName();
      return EMERGENCY_NAME ? EMERGENCY_NAME : "緊急事態区分なし";
    },

    // 配信日時フィルタ処理
    registrationDateFilter(value) {
      this.firstPage();
      if (!this.startDateValue && !this.endDateValue) {
        return true;
      }
      const formattedStartDate = this.$moment(
        this.startDateValue,
        "YYYY/MM/DD HH:mm:ss"
      );
      const formattedendDate = this.$moment(
        this.endDateValue,
        "YYYY/MM/DD HH:mm:ss"
      );
      if (
        formattedStartDate.isValid() &&
        new Date(value) <= formattedStartDate.toDate()
      ) {
        return false;
      }
      if (
        formattedendDate.isValid() &&
        new Date(value) >= formattedendDate.toDate()
      ) {
        return false;
      }
      return true;
    },

    // 災害名称（災害番号）フィルタ処理
    disasterNameFilter(value) {
      this.firstPage();
      if (!this.disasterNameFilterValue) {
        return true;
      }
      if (this.disasterNameFilterValue === "all") {
        return true;
      }
      if (this.disasterNameFilterValue === "") {
        return true;
      }

      return value === this.disasterNameFilterValue;
    },

    // 配信番号フィルタ
    deliveryNoFilter(value) {
      if (
        // 翻訳状況、配信状況フィルタ処理
        this.translationStatusFilter(value) &&
        this.orderStatusFilter(value)
      ) {
        return true;
      } else {
        return false;
      }
    },

    // 翻訳状況フィルタ処理
    translationStatusFilter(value) {
      this.firstPage();
      if (
        !this.translationStatusFilterValue ||
        this.translationStatusFilterValue.length === 0
      ) {
        return true;
      }
      // 翻訳済み選択：翻訳状況（各言語）の全ての状況が「翻訳済み」もしくは「-」のレコードを抽出
      if (this.translationStatusFilterValue === "0") {
        let detail = this.disasterDeliverys.filter(
          item => item.delivery_no === value
        );
        if (
          detail[0].translation_status_en === "0" ||
          detail[0].translation_status_ko === "0" ||
          detail[0].translation_status_zh_cn === "0" ||
          detail[0].translation_status_zh_tw === "0"
        ) {
          return true;
        } else {
          return false;
        }
        // 翻訳待ち選択：翻訳状況（各言語）に1つでも「翻訳待ち」のステータスとなっているレコードを抽出
      } else if (this.translationStatusFilterValue === "1") {
        let detail = this.disasterDeliverys.filter(
          item => item.delivery_no === value
        );
        if (
          detail[0].translation_status_en !== "0" &&
          detail[0].translation_status_ko !== "0" &&
          detail[0].translation_status_zh_cn !== "0" &&
          detail[0].translation_status_zh_tw !== "0"
        ) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },

    // 配信種別フィルタ処理
    orderTypeFilter(value) {
      this.firstPage();
      if (
        !this.ordertypeFilterValue ||
        this.ordertypeFilterValue.length === 0
      ) {
        return true;
      }
      return this.ordertypeFilterValue.includes(value);
    },

    // LINE連携フィルタ処理
    lineFilter(value) {
      this.firstPage();
      if (!this.lineFilterValue || this.lineFilterValue.length === 0) {
        return true;
      }
      if (this.lineFilterValue) {
        return value === IS_POST;
      }
      return true;
    },

    // Twitter連携フィルタ処理
    twitterFilter(value) {
      this.firstPage();
      if (!this.twitterFilterValue || this.twitterFilterValue.length === 0) {
        return true;
      }
      if (this.twitterFilterValue) {
        return value === IS_POST;
      }
      return true;
    },

    // 配信状況フィルタ処理
    orderStatusFilter(value) {
      this.firstPage();
      if (
        !this.orderStatusFilterValue ||
        this.orderStatusFilterValue.length === 0
      ) {
        return true;
      }
      let detail = this.disasterDeliverys.filter(
        item => item.delivery_no === value
      );
      let result = false;
      for (let index = 0; index < this.orderStatusFilterValue.length; index++) {
        // 未配信、配信中
        // LINE、Twitter関係なし
        if (
          this.orderStatusFilterValue[index] === DELIVERY_STATUS_NON ||
          this.orderStatusFilterValue[index] === DELIVERY_STATUS_LIVE
        ) {
          if (
            this.orderStatusFilterValue[index] === detail[0].delivery_status
          ) {
            result = true;
          }
          // 配信済、一部配信
          // LINE、Twitterの配信ステータスが配信失敗でない場合
        } else if (
          this.orderStatusFilterValue[index] === DELIVERY_STATUS_DONE ||
          this.orderStatusFilterValue[index] === DELIVERY_STATUS_PART
        ) {
          if (
            this.orderStatusFilterValue[index] === detail[0].delivery_status &&
            !this.isExistsErrorStatus(detail[0])
          ) {
            result = true;
          }
          // 配信失敗
          // プッシュ通知（緊急速報メール）、LINE、Twitterのいずれかが配信失敗の場合
        } else if (this.orderStatusFilterValue[index] === DELIVERY_STATUS_ERR) {
          if (
            detail[0].delivery_status !== DELIVERY_STATUS_NON &&
            detail[0].delivery_status !== DELIVERY_STATUS_LIVE &&
            this.isExistsErrorStatus(detail[0])
          ) {
            result = true;
          }
        }
      }
      return result;
    },

    // 緊急事態区分フィルタ処理
    emergClsFilter(value) {
      this.firstPage();
      if (!this.emergClsFilterValue || this.emergClsFilterValue.length === 0) {
        return true;
      }
      return this.emergClsFilterValue.includes(value);
    },

    // 1ページ目に戻す処理
    firstPage() {
      if (this.$refs.topOpeDataTable) {
        this.$refs.topOpeDataTable.resetPage();
      }
    },

    // 最新の情報に更新
    async reload() {
      this.overlay = true;
      await this.$store
        .dispatch("disasterDelivery/loadDisasterDelivery")
        .catch(e => {
          this.handleGetError(e);
          this.overlay = false;
        });
      this.disasterDeliverys = this.$store.state.disasterDelivery.data.results;
      this.overlay = false;
    },

    // 緊急事態区分並び替え
    emergClsSorter(a, b) {
      if (a !== b) {
        // 配列の格納順でソート
        const sortList = [
          EmergencyClass.NL,
          EmergencyClass.AL,
          EmergencyClass.SE,
          EmergencyClass.GE,
          EmergencyClass.FN
        ];
        const indexA = sortList.indexOf(a);
        const indexB = sortList.indexOf(b);
        if (indexA > indexB) {
          return 1;
        } else {
          return -1;
        }
      }
      return 0;
    }
  }
};
</script>

<style scoped>
.table-flex {
  white-space: nowrap;
}
</style>
